import React, { useState } from 'react';
import { Input } from 'reactstrap';
import NewDesign from '..';
import { CommonIcons } from 'components/Icons';

const propTypes = {};

const DateTimePicker = (props) => {
  //! State
  const [value, setValue] = useState(new Date().toISOString().replaceAll('Z', ''));

  //! Function
  const onClickClear = () => {
    setValue('');
  };

  //! Render
  return (
    <div className='new-design-datetime'>
      <Input
        type='datetime-local'
        onChange={(e) => {
          console.log(e.target.value);
          setValue(e.target.value);
        }}
        value={value}
        {...props}
      />
      <NewDesign.Typography className='new-design-datetime__clear' onClick={onClickClear}>
        <CommonIcons.Close />
      </NewDesign.Typography>
    </div>
  );
};

DateTimePicker.propTypes = propTypes;
export default DateTimePicker;
